export const NAME = 'enterprisecard';

export const REQUEST_ENTERPRISE_CARD_PAY = 'REQUEST_ENTERPRISE_CARD_PAY';
export const SUCCESS_ENTERPRISE_CARD_PAY = 'SUCCESS_ENTERPRISE_CARD_PAY';
export const FAILURE_ENTERPRISE_CARD_PAY = 'FAILURE_ENTERPRISE_CARD_PAY';



// WEBPACK FOOTER //
// ./src/services/enterprisecard/constants.js